export default function ConditionalLoader({ isLoading, loader, children }: any) {
  if (isLoading) return loader

  return children
}
